import { useEffect } from 'react';
import { Box, List } from '@mui/material';
import { useCampaignWizardContext } from '../../../../hooks/useCampaignWizard';
import { ListItemButton, ListItemLabel } from './CampaignWizardStyles';
import { ScrollableSection } from '../../../../hooks/ScrollSpy';
import { useScrollSpy } from '../../../../hooks/ScrollSpy';

type CampaignWizardGeographyStepNavProps = {
    // step: number;
    onStep?: (step: number) => void;
};

export const sections: ScrollableSection[] = [
    { index: 1, id: 'campaign-wizard-targeting-location' },
    { index: 2, id: 'campaign-wizard-targeting-audience' },
];

export default function CampaignWizardGeographyStepNav(props: CampaignWizardGeographyStepNavProps) {
    const { onStep } = props;
    const { hasError } = useCampaignWizardContext();
    const { activeSection, jumpToActiveSection } = useScrollSpy({ sections });

    const handleListItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number) => {
        jumpToActiveSection(index);
    };

    useEffect(() => {
        if (onStep) {
            onStep(activeSection);
        }
    }, [onStep, activeSection]);

    const hasErrorSection = (section: string): boolean => {
        switch (section) {
            case 'Location':
                return hasError('adGroups.*.adGroupLocations');

            case 'Audience':
                return hasError('adGroups.*.adGroupAudienceSources');
        }

        return false;
    };

    return (
        <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
            <List component="nav" aria-label="secondary mailbox folder">
                <ListItemButton selected={activeSection === 3} onClick={(event) => handleListItemClick(event, 3)}>
                    <ListItemLabel error={hasErrorSection('Audience')} primary="Audience" />
                </ListItemButton>
                {/*<ListItemButton selected={activeSection === 2} onClick={(event) => handleListItemClick(event, 2)}>
                    <ListItemText primary="Device" />
                </ListItemButton>*/}
                <ListItemButton selected={activeSection === 1} onClick={(event) => handleListItemClick(event, 1)}>
                    <ListItemLabel error={hasErrorSection('Location')} primary="Location" />
                </ListItemButton>
            </List>
        </Box>
    );
}
